module.exports = __webpack_public_path__ + "img/speciality.66f2ce15.png";